module.exports = __webpack_public_path__ + "img/Truppführer_Technik_und_Sicherheit.01f71d05.svg";